<input
	#input
	type="text"
	class="search-input"
	placeholder="Type a command or search..."
	(input)="onInput($event)"
	autofocus
/>
